import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function CategoryQuickEntry() {
  return (
    <section className="w-full px-4 md:px-8 py-8 md:py-10">
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-900">
          分类快捷通道
        </h2>
        <Link
          to="/category/short-video"
          className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1"
        >
          全部分类
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.id}`}
            className="group flex flex-col items-center gap-2 py-4 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-primary-50 transition-colors cursor-pointer"
          >
            <span className="w-11 h-11 rounded-lg bg-background-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 flex items-center justify-center transition-colors">
              <i className={`${cat.icon} text-2xl`}></i>
            </span>
            <span className="text-sm font-medium text-foreground-800">{cat.name}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}